import Webhooks from 'shared/webhooks';
import useWebhooksHostProps from './useWebhooksHostProps';

// SettingsPage's PartnerSettingsApiProvider points the page's calls at the partner's own webhook routes.
export default function WebhooksPage() {
  const hostProps = useWebhooksHostProps();

  return <Webhooks {...hostProps} />;
}
